export const LMT_ENHCMT_updateCurrentScreenReducer = {
  LMT_ENHCMT_updateCurrentScreen: (state, action) => {
    const { screenConstHistory, currentScreen, previousScreen } = state;
    if (screenConstHistory)
      state.screenConstHistory = [
        ...state.screenConstHistory,
        [previousScreen, action.payload],
      ];
    const screenConstHistoryLength = state.screenConstHistory.length;
    const tenRecordsFromLast = screenConstHistoryLength - 10;
    state.screenConstHistory = state.screenConstHistory.slice(
      tenRecordsFromLast < 0 ? 0 : tenRecordsFromLast,
      screenConstHistoryLength
    );
    state.currentScreen = action.payload;
  },
};
